import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Header.module.scss';

/**
 * Card Header Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {object} props.children - Child components
 * @param {string} props.className - Additional class name
 * @param {object} props.otherProps - Additional props
 */
const Header = React.forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div ref={ref} className={classnames(styles['header'], className)} {...otherProps}>
            {children}
        </div>
    );
});

Header.displayName = 'Header';

Header.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Header;
